import React from "react";
import Input from "app/components/Input";
import UserIcon from "app/components/Icons/UserIcon";
import PasswordIcon from "app/components/Icons/PasswordIcon";
import TimezoneSelection from "app/components/TimezoneSelection";
import useCreateProfile from "../hooks/useCreateProfile";

export default function ProfileFields() {
  const {
    isLoading,
    isGoogleLogin,
    name,
    password,
    confirmPassword,
    timezone,
    handleChange,
    handleSelect,
  } = useCreateProfile();

  return (
    <div className="flex flex-col gap-3 ">
      <Input
        id="name"
        label="Full Name"
        placeholder="Enter your name"
        icon={<UserIcon color="#BDC0C4" size={20} />}
        value={name.value}
        onChange={handleChange}
        error={name.error}
        name="name"
        disabled={isLoading}
      />
      <TimezoneSelection
        value={timezone.value}
        onChange={(val) => {
          handleSelect("timezone", val);
        }}
        label="Country/Timezone"
        id="timezone"
        placeholder="Choose country/timezone"
        searchPlaceholder="Search by country/timezone name"
        isOnboarding
      />
      {!isGoogleLogin && (
        <>
          <Input
            id="password"
            label="Password"
            type="password"
            placeholder="Enter your password"
            icon={<PasswordIcon color="#BDC0C4" size="24" />}
            value={password.value}
            onChange={handleChange}
            error={password.error}
            name="password"
            disabled={isLoading}
            isShowWarningIcon
          />
          <Input
            id="confirmPassword"
            label="Confirm Password"
            type="password"
            placeholder="Confirm your password"
            icon={<PasswordIcon color="#BDC0C4" size="24" />}
            value={confirmPassword.value}
            onChange={handleChange}
            error={confirmPassword.error}
            name="confirmPassword"
            disabled={isLoading}
            isShowWarningIcon
          />
        </>
      )}
    </div>
  );
}
